import type { ReactElement } from 'react';

export interface NoDataProps {
  /**
   * What is missing, for screen readers and for the tooltip — e.g.
   * «рыночные данные недоступны». The visible text stays the same short
   * «нет данных» so a dense table does not turn into prose.
   */
  readonly reasonRu?: string;
}

/**
 * «нет данных» — the panel's one and only way of saying a value is unknown.
 *
 * This exists because the alternatives are all worse. A zero is a number the
 * operator will read as a measurement. An em dash alone is ambiguous: it could
 * equally mean "zero", "not applicable" or "still loading". A blank cell reads
 * as a rendering bug. Only an explicit Russian «нет данных» says the one true
 * thing — the system does not know this value right now.
 *
 * Used for every nullable field the server sends as `null` because a dependency
 * is down: the price, the balance, the mark price and the two P&L figures
 * derived from it, the candle close time.
 */
export function NoData({ reasonRu }: NoDataProps): ReactElement {
  return (
    <span className="no-data" title={reasonRu}>
      нет данных
      {reasonRu !== undefined && <span className="visually-hidden">: {reasonRu}</span>}
    </span>
  );
}
